import { useState } from 'react';
import { Button } from '@mui/material';
import { useExportEnquiriesQuery } from 'state/api';

const ToolbarExport = ({ exportType }) => {
  const [skip, setSkip] = useState(true);
  const { isLoading, data } = useExportEnquiriesQuery({}, { skip });
  const url = isLoading
    ? ''
    : window.URL.createObjectURL(new Blob([data], { type: 'octet/stream' }));
  return (
    <Button
      onMouseEnter={() => setSkip(false)}
      disabled={isLoading}
      href={url}
      download={`${exportType}.csv`}
    >
      Export
    </Button>
  );
};

export default ToolbarExport;
